import HardBreak from '@tiptap/extension-hard-break';
import Link from '@tiptap/extension-link';
import StarterKit from '@tiptap/starter-kit';

/**
 * Hard break that serialises as `\` + newline rather than the CommonMark
 * default of two trailing spaces + newline. Both forms parse to the same
 * `<br>`, but legacy database content (originally produced by `markdown-draft-js`)
 * uses the backslash form, so we keep that for byte-stable round-trips.
 */
const MarkdownAwareHardBreak = HardBreak.extend({
  renderMarkdown: () => '\\\n',
});

export const baseEditorExtensions = [
  // StarterKit v3 bundles Link and HardBreak. Disable the bundled versions
  // so the explicit `Link.configure(...)` and `MarkdownAwareHardBreak` below
  // remain authoritative.
  StarterKit.configure({ link: false, hardBreak: false }),
  Link.configure({
    openOnClick: 'whenNotEditable',
    autolink: true,
  }),
  MarkdownAwareHardBreak,
];
